module.exports = {
	ID3Info: require("./ID3Info").default,
	Sound: require("./Sound").default,
	SoundChannel: require("./SoundChannel").default,
	SoundLoaderContext: require("./SoundLoaderContext").default,
	SoundMixer: require("./SoundMixer").default,
	SoundTransform: require("./SoundTransform").default,
	Video: require("./Video").default,
}